// components/layout/Sidebar.jsx
// 左侧栏: 分子筛选 + 体系列表 + 总数据点统计

import { useSolPred } from '../../hooks/useSolPredStore';

export default function Sidebar() {
  const {
    searchQuery, setSearchQuery,
    selectedMolecules, setSelectedMolecules, toggleMolecule, ALL_MOLECULES,
    filteredSystems, selectedSystem, handleSelectSystem,
    stats,
  } = useSolPred();

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="section-tag">体系目录 · Systems</div>
        <div className="sidebar-search">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
            <circle cx="11" cy="11" r="7" />
            <path d="M21 21l-4-4" strokeLinecap="round" />
          </svg>
          <input
            placeholder="按组分或体系号检索..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      <div className="filter-section">
        <div className="filter-header">
          <span className="filter-title">分子选择</span>
          <span className="filter-hint" onClick={() => setSelectedMolecules(new Set())}>
            {selectedMolecules.size > 0 ? `清除 (${selectedMolecules.size})` : '多选筛选'}
          </span>
        </div>
        <div className="molecule-grid">
          {ALL_MOLECULES.map(m => (
            <button
              key={m}
              type="button"
              className={`molecule-pill ${selectedMolecules.has(m) ? 'active' : ''}`}
              onClick={() => toggleMolecule(m)}
            >{m}</button>
          ))}
        </div>
      </div>

      <div className="system-list">
        {filteredSystems.length === 0 ? (
          <div className="empty-state">
            <div style={{ fontSize: 24, marginBottom: 8 }}>○</div>
            <div style={{ fontSize: 12, color: 'var(--text-3)' }}>未找到匹配体系</div>
            <div style={{ fontSize: 10, color: 'var(--text-4)', marginTop: 4 }}>调整筛选条件</div>
          </div>
        ) : filteredSystems.map(sys => (
          <div
            key={sys.id}
            className={`system-card ${selectedSystem.id === sys.id ? 'active' : ''}`}
            onClick={() => handleSelectSystem(sys)}
          >
            <div className="system-id-row">
              <span className="system-id">{sys.id}</span>
              <span className={`status-chip ${sys.status}`}>
                {sys.status === 'production' ? '已上线' : sys.status === 'training' ? '训练中' : '排队'}
              </span>
            </div>
            <div className="system-formula">{sys.components.join(' + ')}</div>
            <div className="system-meta">
              <span>
                <i className={`dot ${sys.hasModel ? 'green' : sys.status === 'training' ? 'amber' : 'gray'}`} />
                {sys.hasModel ? `R² ${sys.r2}` : '待训练'}
              </span>
              <span>📊 {sys.dataPoints}</span>
              <span>🌡 {sys.tempRange[0]}–{sys.tempRange[1]}°C</span>
            </div>
          </div>
        ))}
      </div>

      <div className="sidebar-footer">
        <div className="stat-grid">
          <div className="stat-mini">
            <div className="stat-mini-label">总数据点</div>
            <div className="stat-mini-value">{(stats.total / 1000).toFixed(1)}K</div>
          </div>
          <div className="stat-mini">
            <div className="stat-mini-label">在线模型</div>
            <div className="stat-mini-value">
              {stats.trained}
              <span style={{ color: 'var(--text-4)', fontSize: 11 }}> /{stats.totalSystems}</span>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
